import { checkVersion } from './appVersion'

export const appFetch = async (
  url: string,
  options: {
    method: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE'
    body?: Record<string, unknown>
    headers?: Record<string, string>
  } = { method: 'GET' },
): Promise<Response> => {
  const fetchOptions: RequestInit = {}

  let headers: Record<string, string> = {}
  if (options.headers) {
    headers = options.headers
  }

  if (['GET'].includes(options.method) && options.body != undefined) {
    throw new Error('Body not be used on GET requests')
  }
  if (typeof options?.body === 'object') {
    fetchOptions.body = JSON.stringify(options.body)
  } else if (typeof options.body === 'string') {
    fetchOptions.body = options.body
  }

  headers['Content-Type'] = 'application/json'
  fetchOptions.headers = headers
  fetchOptions.method = options.method

  const response = await fetch(url, fetchOptions)
  checkVersion(response)
  return response
}
